var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"demo__StatusBadge",class:['demo__bg--' + _vm.style.bg, 'demo__color--' + _vm.style.color],style:({
    ..._vm.pos,
  })},[(_vm.status.text)?_c('span',[_vm._v(" "+_vm._s(_vm.status.text)+" ")]):_c('span',[_vm._v(" "+_vm._s(_vm.$t("status." + _vm.status.type))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }